<template>
  <div class="right-nav" style="right: 0px;">
    <div class="right-con" style="top: 50%; margin-top: -206.5px;">
<!--      <div class="rg-logo"></div>-->
      <div class="rg-line"></div>
      <a id="sideCart" href="javascript:;" class="rg-cart"><i class="icon"></i>
        <div class="rg-text" @click="goToShopCart()">购物车 </div>
        <div v-if="isShowNum" class="num cart-total-num" ><span ><b v-text="cartNumber === 0 ? '0' : cartNumber"></b></span></div>
      </a>
      <div class="rg-line"></div>
      <div class="rg-service-ico"></div>
      <div class="rg-service rg-kefu">
        <a href="tencent://message/?uin=2289120125&Site=&menu=yes" target="_blank" class="rg-text">客服</a>
      </div>
<!--      <a href="www.baidu.com" target="_blank" class="rg-text">售后</a>-->
      <div class="rg-line" style="margin-top: 5px;"></div>
<!--      <a href="javascript:;" class="rg-fb"><i class="icon"></i><div class="rg-text">建议</div></a>-->
    </div>

    <div class="rg-goTop rg-service" style="display: block;">
      <div class="rg-service-nav" style=" right: 80px; display: none;">返回顶部</div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {listSearchMixin} from '../../config/mixin'
import api from '@/api'
import Cookie from 'js-cookie'

export default {
  mixins: [listSearchMixin],
  name: 'rightNav',
  data () {
    return {
      isShowNum: false
    }
  },
  created () {
    if (Cookie.get('token')) {
      this.isShowNum = true
      this.getTrolleyList()
    } else {
      this.isShowNum = false
    }
  },
  computed: {
    ...mapGetters([
      'cartNumber'
    ])
  },
  methods: {
    ...mapMutations({
      setCartNumber: 'SET_CARTNUMBER'
    }),

    goToShopCart () {
      this.$router.push({path: '/shopping-trolley'})
    },
    async getTrolleyList () {
      const vm = this
      const params = {
        url: api.getTrolleyList,
        method: 'GET'
      }
      vm.sendReq(params, res => {
        const d = res.data.valid
        let cartNumber = 0
        cartNumber = d.length
        this.setCartNumber(cartNumber)
      })
    }
  }
}
</script>

<style scoped>
.right-nav {
  color: #fff;
  width: 40px;
  background: #030000;
  text-align: center;
  font-size: 12px;
  position: fixed;
  right: -40px;
  top: 0;
  bottom: 0;
  z-index: 10000;
}
.right-nav .right-con {
  width: 100%;
  background: #030000;
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 3;
}
.right-nav .rg-fb .icon {
  display: block;
  width: 22px;
  height: 22px;
  background: url(../../../static/image/rg-fb.png) no-repeat;
  margin: 12px auto 8px auto;
}
.right-nav .rg-service-ico {
  width: 22px;
  height: 22px;
  background: url(../../../static/image/rg-service.png) no-repeat;
  margin: 12px auto 8px auto;
}
.right-nav .rg-line {
  width: 30px;
  height: 1px;
  line-height: 0;
  font-size: 0;
  background: #434343;
  margin: 0 auto;
}
.right-nav .rg-text {
  display: block;
  line-height: 16px;
  color: #fff;
  padding: 4px 10px;
  cursor: pointer;
}
.right-nav .rg-goTop {
  width: 100%;
  height: 30px;
  background: url(../../../static/image/rg-goTop.png) no-repeat center;
  /*cursor: pointer;*/
  display: none;
  position: absolute;
  left: 0;
  bottom: 0px;
  z-index: 2;
}

.right-nav .rg-cart .icon {
  display: block;
  width: 24px;
  height: 18px;
  background: url(../../../static/image/rg-cart.png) no-repeat;
  margin: 0 auto;
}

.right-nav .rg-cart .num {
  width: 22px;
  height: 22px;
  line-height: 22px;
  margin: 0 auto;
  background: #d22929;
  font-size: 13px;
  border-radius: 50%;
  font-style: normal;
  overflow: hidden;
  color: #ffffff;
  /*display: none;*/
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/rightNav.vue